import React from "react";
import { NavLink } from "react-router-dom";
import { FaHouse, FaTicket, FaCode, FaBook, FaUserPlus, FaUserShield, FaComments } from "react-icons/fa6";
import knowledgebase from "../assets/knowledgebase.png";
import { LuUserRoundPlus } from "react-icons/lu";
import { BookOpenText, CodeXml, Headset, Home, MessageSquare, Ticket, Tickets, UserRoundPlus } from "lucide-react";

const Sidebar = ({ isOpen }) => {
  const organizationName = sessionStorage.getItem("organizationName");
  const role = sessionStorage.getItem(`${organizationName}_role`);
  const features = sessionStorage.getItem(`${organizationName}_features`) || 'livechat,tickets';
  const hasLiveChat = features.includes('livechat');
  const hasTickets = features.includes('tickets');
  return (
    <div
      className={` fixed bg-[#205781] inset-y-0 left-0 transform ${
        isOpen ? "translate-x-0" : "-translate-x-full"
      } 
    transition-transform duration-300 ease-in-out bg-[#2532d6] 
    sm:relative sm:translate-x-0 w-64 sm:w-20 p-4 text-black flex flex-col 
    border-r-2 border-solid border-gray-400 h-screen overflow-y-auto
    ${isOpen ? "z-50" : "z-30"}`}
    >
      <div className="flex flex-col space-y-6 flex-1">
        <NavLink
          to={`/${organizationName}/home/dashboard`}
          title="Dashboard"
          className={({ isActive }) =>
            `flex  items-center p-2 rounded-lg ${
              isActive ? "bg-blue-900" : "hover:bg-blue-900"
            }`
          }
        >
          <Home className="text-white ml-1"/> 
          {/* <FaHouse className="text-2xl ml-1 text-white"/> */}
          <span className="ml-3 sm:hidden">Dashboard</span>
        </NavLink>
        {role === "superadmin" && (
        <NavLink
          to={`/${organizationName}/home/admins`}
          title="Admins"
          className={({ isActive }) =>
            `flex  items-center p-2 rounded-lg ${
              isActive ? "bg-blue-900" : "hover:bg-blue-900"
            }`
          }
        >
          <FaUserShield className="text-2xl ml-1 text-white"/>
          <span className="ml-3 sm:hidden">Admins</span>
        </NavLink>
        )}
        {(role === "admin" || role === "agent") && hasLiveChat && (
        <NavLink
          to={`/${organizationName}/home/LiveChat`}
          title="Live Chat"
          className={({ isActive }) =>
            `flex  items-center p-2 rounded-lg ${
              isActive ? "bg-blue-900" : "hover:bg-blue-900"
            }`
          }
        >
          <MessageSquare className="ml-1 text-white"/>
          <span className="ml-3 sm:hidden">Live Chat</span>
        </NavLink>
        )}
        {(role === "admin" || role === "agent") && hasTickets && (
        <NavLink
          to={`/${organizationName}/home/ticket`}
          title="Ticket"
          className={({ isActive }) =>
            `flex  items-center p-2 rounded-lg ${
              isActive ? "bg-blue-900" : "hover:bg-blue-900"
            }`
          }
        >
          <Tickets className=" ml-1 text-white"/>
          <span className="ml-3 sm:hidden">Ticket</span>
        </NavLink>
        )}
         {(role === "admin" || role === "agent") && (
        <NavLink
          to={`/${organizationName}/home/knowledgebase`}
          title="Knowledge Base"
          className={({ isActive }) =>
            `flex  p-2 items-center rounded-lg ${
              isActive ? "bg-blue-900" : "hover:bg-blue-900"
            }`
          }
        >
          <BookOpenText className="ml-1 text-white"/> 
          {/* <FaBook className="text-2xl ml-1 text-white"/> */}
          <span className="ml-3 sm:hidden">Knowledge Base</span>
        </NavLink>
        )}
        {role === "admin" && (
          <NavLink
            to={`/${organizationName}/home/agent`}
            title="Agent"
            className={({ isActive }) =>
              `flex  p-2 items-center rounded-lg ${
                isActive ? "bg-blue-900" : "hover:bg-blue-900"
              }`
            }
          >
            <UserRoundPlus className="ml-1 text-white"/> 
            {/* <FaUserPlus className="text-2xl ml-1 text-white"/> */}
            <span className="ml-3 sm:hidden">Add Agent</span>
          </NavLink>
        )}
        {role === "admin" &&(
        <NavLink
            to={`/${organizationName}/home/script`}
            title="script"
            className={({ isActive }) =>
              `flex  p-2 items-center rounded-lg ${
                isActive ? "bg-blue-900" : "hover:bg-blue-900"
              }`
            }
          >
            <CodeXml className="ml-1 text-white"/> 
            {/* <FaCode className="text-2xl ml-1 text-white"/> */}
            <span className="ml-3 sm:hidden">Script Code</span>
          </NavLink>
        )}
      </div>

      {/* Support Link - pinned to bottom */}
      <div className="mt-auto pt-4 border-t border-blue-400">
        <a
          href="https://4xportal.com/contact-us/"
          target="_blank"
          rel="noopener noreferrer"
          title="Support"
          className="flex items-center p-2 rounded-lg hover:bg-blue-900 transition-colors"
        >
          <Headset className="ml-1 text-white" />
          <span className="ml-3 sm:hidden">Support</span>
        </a>
      </div>
    </div>
  );
};

export default Sidebar;
